import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

export interface UpdateRoomPartyInput {
    data: {
        id: number
        group_booking_id?: number
        hotel_resource_id?: number | null
        disabled?: boolean
        start_date?: string
        end_date?: string
        wheelchair_access?: boolean,
        has_infants?: boolean,
        notes?: string,
        members_different_dates?: boolean
    }
}

interface UpdateRoomPartyData {
    __typename?: string,
    updateRoomParty: RoomParty
}

export const UPDATE_ROOM_PARTY_MUTATION = gql`
    mutation updateRoomParty($data: UpdateRoomPartyInput!) {
        updateRoomParty(data: $data) {
            ${gqlRoomParty}
        }
    }
`;

export const updateRoomParty = () => useMutation<UpdateRoomPartyData, UpdateRoomPartyInput>(
    UPDATE_ROOM_PARTY_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default updateRoomParty;